<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content background-light align-left">
			<div class="row">
				<div class="columns column6">
					<div v-parse-links v-html="page.details" />
					<picture>
						<source v-if="page.sideImageWebp" :srcset="page.sideImageWebp" type="image/webp" />
						<source :srcset="page.sideImage" />
						<img :src="page.sideImage" class="extra-image" loading="lazy" :alt="page.sideImageAlt" />
					</picture>
				</div>
				<div class="columns column5 right package-icons">
					<div v-for="item in page.extras" :key="item.id" class="package-icon">
						<font-awesome-icon :icon="`fal fa-${item.icon}`" size="1x" />
						<span>{{ item.content }}</span>
					</div>
				</div>
			</div>
		</section>

		<section class="package-prefooter">
			<div class="row align-center">
				<div class="columns column12">
					<div v-parse-links v-html="page.bannerContent" />
					<a
						v-if="page.bookingUrl"
						class="button cta"
						target="_blank"
						rel="noopener noreferrer"
						:href="page.bookingUrl"
					>
						{{ $t('bookNow') }}
					</a>
					<book-button v-else class="button cta">
						{{ $t('bookNow') }}
					</book-button>
				</div>
			</div>
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>

<style lang="scss">
.package-prefooter {
	padding: 50px 0;
	background: $contentblock-background-color;
}

.extra-image {
	width: 100%;
	max-width: 600px;
	margin: 20px auto 0;
}

.package-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: stretch;
}

.package-icon {
	width: 46%;
	background: #fff;
	padding: 40px 30px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	text-align: center;
	margin: 10px auto;
}

.package-icon i,
.package-icon svg {
	color: $cta-color;
	font-size: 66px;
	margin: 0 auto 40px;
}

.package-icon span {
	width: 100%;
	font-size: 18px;
}

@media (max-width: 920px) {
	.package-icons {
		width: 100%;
	}
}

@media (max-width: 680px) {
	.package-icon {
		padding: 30px 20px;
		width: 48%;
	}

	.package-icon i,
	.package-icon svg {
		font-size: 58px;
	}

	.package-icon span {
		font-size: 16px;
	}
}
</style>
